import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from '../providers/auth.service';

@Injectable()

export class AuthGuardService implements CanActivate {

    constructor(private authService: AuthService, private router: Router) { }

    canActivate() {
        const isTokenValid = this.authService.isAuthTokenValid();

        if (!isTokenValid) {
            this.router.navigate(['/']);

            return false;
        }

        return true;
    }
}
